import { render, staticRenderFns } from "./lbt.vue?vue&type=template&id=0166266b&scoped=true&"
import script from "./lbt.vue?vue&type=script&lang=js&"
export * from "./lbt.vue?vue&type=script&lang=js&"
import style0 from "./lbt.vue?vue&type=style&index=0&id=0166266b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0166266b",
  null
  
)

export default component.exports